import { Component, OnInit, ViewContainerRef, EventEmitter, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { CruiseService } from '../services/cruise.service';
import { RechargeService } from '../services/recharge.service';
import { PLATFORM_ID, Inject } from '@angular/core';
import { PlatformLocation, isPlatformServer, isPlatformBrowser } from '@angular/common';

// import { HttpClient, HttpEventType } from '@angular/common/http';
declare var jQuery: any;
declare var window: any;
declare var $: any;
declare var moment: any;

@Component({
    selector: 'app-rechargehome',
    templateUrl: './rechargehome.component.html',
    styleUrls: ['./rechargehome.component.css'],
    providers: [CruiseService, DatePipe]
})
export class RechargeHomeComponent implements OnInit {

    public username: any; esimDeals: any[] = [];
    public password: any; public planListarray: any = []; public planList: any = []; orgCnt: any = "";
    public isAgentLoggedIn: any = false; private imageError: any = ''; public rechargeBundle: any = {}; public activationBundle: any = {};
    public portaltype: any = ''; activation: any = '';
    public email: any = ''; public circleName: any = ''; public operatorName: any = '';
    public Bookingref: any = ''; public Operatorslist: any = [];
    public ticketUrls: any = ""; public rechargeData: any = {}; public registerStatus: any = [];
    public filename: any = ""; public circle: any = ''; public BillerID: any = ''; public operator: any = '';
    public trans: any = "";
    public GSTNdiv: any = ''; public mobile: any = ""; public operatorSelect: any = ""; public planType: any = "";
    public Callagentremarks: any = ''; public availableMedia: any = []; public availableMediaLogo: any = [];
    public Callagentemail: any = ''; public amount: any = ""; public activationlist: any[]; public rechargelist: any[]; public rechargelistData: any[];
    public Callmobile: any = ''; public balancestr: any = 0;
    private merchantsetup: any = {};
    private merchantsetups: any = {};
    fileData: File = null;
    previewUrl: any = null;
    fileUploadProgress: string = null;
    uploadedFilePath: string = null;
    public logo: any = "http://flights.ibe4all.com/images/logo.jpg";
    public fileUrl: any;
    public file: File = null; private base64string: any = ''; private fileName: any = ''; private baseURL: any = ''; private fullURL: any = '';
    public activationplan: any = ''; public sim: any = ''; public firstname: any = ''; public lastname: any = ''; public simNo: any = '';
    public postalcode: any = ''; public address1: any = ''; public address2: any = ''; public state: any = ''; paymentInitiate: any = "";
    public traveldate: any = ''; public passport: any = ''; public altmobile: any = ''; public visaimage: any = ''; public passportimage: any = ''; public ticketimage: any = '';
    // Labels
    public logintxt: any = 'Agent Sign In'; public signuptxt: any = 'Agent Sign Up';
    public loginType = ''; private logindata: any = ''; private rooms: any = ''; public refcode: any; public agentcode: any = "";
    public contact: any = ''; memail: any = ''; mname: any = ''; public about: any = ''; AgentUserLoginId: any = ''; userType: any = '';
    public options: any = {
        autoApply: true,
        "locale": { "format": "DD/MM/YYYY" },
        singleDatePicker: true,
        showDropdowns: true,
        minDate: moment().format('DD-MM-YYYY'),
    };

    constructor(@Inject(PLATFORM_ID) private platformId: Object,
        private loginService: CruiseService, private toastr: ToastrService, private vcr: ViewContainerRef, private titleService: Title, private meta: Meta,
        public router: Router, platformLocation: PlatformLocation, private rechargeService: RechargeService, private datePipe: DatePipe) {
        this.baseURL = (platformLocation as any).location.origin; this.fullURL = (platformLocation as any).location.pathname;
        this.merchantsetup = this.loginService.getSetupData();
        this.loginType = this.loginService.getloginType(); this.titleService.setTitle("International SIM cards, eSIMS and data solutions while traveling abroad");
        this.meta.addTag({ name: 'Description', content: "Your one-stop-shop for international SIM cards, eSIMS and data solutions while traveling abroad. Stay connected with our seamless, affordable, and reliable mobile connectivity wherever you go and enjoy free incoming. Explore our range of products and enjoy a worry-free travel experience." });
        this.meta.addTag({ name: 'Keywords', content: "International Sim Card | eSim | Prepaid Roaming Sim Card" });

        if (this.merchantsetup.portaltype == "B2B") {
            if (!sessionStorage.getItem("isAgentLoggedIn")) {
                this.router.navigate(["login"]);
            }
        }

        sessionStorage.removeItem("b2crechangePlan");
        // this.getExclusiveDeals("Exclusive Deals");
    }

    ngOnInit() {

        try {
            if (this.availableMediaLogo.length == 0) {
                this.logo = "assets/images/logo.png";
            } else {
                this.logo = this.availableMediaLogo[0].ImageURL;
            }
        } catch (errormsg) { console.log(errormsg); }

        // setTimeout(() => {
        //     this.traveldate = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
        // }, 1000);
        this.getRechargePlans('call'); this.getRechargePlans('data');
        this.getActivationPlans('call'); this.getActivationPlans('data');

        setTimeout(() => {
            jQuery('.owl-carousel.hero-bg-slideshow').owlCarousel({
                margin: 30,
                autoplay: true,
                loop: false,
                rewind: true,
                autoplayTimeout: 2000,
                lazyLoad: true,
                nav: true,
                navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
                responsive: {
                    0: { items: 1, },
                    576: { items: 1, },
                    768: { items: 1, },
                    992: { items: 1, }
                }
            });
        }, 300);
    }
    home() {
        this.router.navigate(["/"]);
    }

    keyPress(event: any) {
        const pattern = /[0-9\ ]/;

        let inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode != 8 && !pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    onlyAlphabets(e: any) {
        try {
            if (window.event) {
                var charCode = window.event.keyCode;
            }
            else if (e) {
                var charCode = e.which;
            }
            else { return true; }
            if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || (charCode == 32))
                return true;
            else
                return false;
        }
        catch (err) {
        }
    }

    makeItBlank(event) {
        jQuery(event.target).val("");
    }

    fillItBack(event, type) {
        if (type == 'mobile')
            jQuery(event.target).val(this.mobile);
        else
            jQuery(event.target).val(this.mobile);
        this.operatorSelect = event.target.value;
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    ProceedRecharge(data) {
        let option = {
            activation: (this.activation),
            country: (this.orgCnt),
            data: data
        };
        sessionStorage.setItem("b2crechangePlan", JSON.stringify(option))
        this.router.navigate(["international-sim/activation/recharge-customer/" + this.orgCnt]);
    }

    getActivationPlans(typ) {
        this.rechargelist = []; this.rechargelistData = [];
        this.rechargeService.fetchactivationplans("", "", "", "", typ, 'Get', 'activationplans').subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    if (typ == 'call')
                        this.rechargelist = resp;
                    if (typ == 'data')
                        this.rechargelistData = resp;
                    this.sort();
                }
            }
        )
    }

    selectPlan(profile) {
        this.activationBundle = profile; this.activationplan = profile.profile; this.amount = profile.price;
    }


    getRechargePlans(typ) {
        this.rechargelist = []; this.rechargelistData = [];
        this.rechargeService.fetchactivationplans("", "", "", "", typ, 'Get', 'rechargeplans').subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    if (typ == 'call')
                        this.rechargelist = resp;
                    if (typ == 'data')
                        this.rechargelistData = resp;
                    this.sort();
                }
            }
        )
    }

    selectPlanRecharge(profile) {
        this.rechargeBundle = profile; this.amount = profile.price;
    }

    // getExclusiveDeals(cruise) {
    //     this.rechargeService.getrechargeOffers(cruise, "", this.loginType).subscribe(
    //         data => {
    //             let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
    //             if (resp.status == 'success') {
    //                 this.esimDeals = resp.externalMaster;
    //                 setTimeout(() => {
    //                     $('.owl-carousel.banner').owlCarousel({
    //                         margin: 30,
    //                         autoplay: true,
    //                         autoplayTimeout: 1000,
    //                         lazyLoad: true,
    //                         rewind: true,
    //                         nav: true,
    //                         navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
    //                         responsive: {
    //                             0: { items: 1, },
    //                             576: { items: 2, },
    //                             768: { items: 3, },
    //                             992: { items: 4, }
    //                         }
    //                     });
    //                 }, 500);
    //             }
    //         },
    //         error => {
    //             console.log(error);
    //         }
    //     )
    // }

    enableActivation() {
        if (!this.orgCnt) {
            this.toastr.warning("Please select the Country of Travel ...!");
            return false;
        }
        if (this.activation == 'activation') { this.getRechargePlans('call'); this.getRechargePlans('data'); }
        if (this.activation == 'recharge' || this.activation == '') { this.getActivationPlans('call'); this.getActivationPlans('data'); }
    }

    sort() {
        this.rechargelist = this.rechargelist.sort((a, b) => a.price - b.price);
        this.rechargelistData = this.rechargelistData.sort((a, b) => a.price - b.price);
    }
}